import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'

// 首页轮播
if ( window.innerWidth> 768) {
    var banner = new Swiper('.banner .swiper-container', {
    autoplay: {
          delay: 5000,
          disableOnInteraction: false,
    },
    speed:1000,
    loop:true,//必须
     on: {
      init: function () {
        renderNumbers(this);
      },
      slideChange: function () {
        renderNumbers(this);
      }
    }
  }); 
}

// 自定义 01 02 03
function renderNumbers(swiper) {
  const slides = swiper.wrapperEl.querySelectorAll(
    '.swiper-slide:not(.swiper-slide-duplicate)'
  );

  const total = slides.length;
  const current = swiper.realIndex;

  const format = (n) => (n < 9 ? "0" + (n + 1) : n + 1);

  let html = "";

  for (let i = 0; i < total; i++) {
    html += `<span class="num ${i === current ? "active" : ""}" data-index="${i}">
      ${format(i)}
    </span>`;
  }

  const container = document.querySelector(".banner .swiper-pagination.custom");
  container.innerHTML = html;

  // 点击跳转（关键点）
  container.querySelectorAll(".num").forEach(el => {
    el.onclick = () => {
      swiper.slideToLoop(parseInt(el.dataset.index));
    };
  });
}


$(".product-nav a").eq(0).addClass("active");
$(".product-list .content").eq(0).addClass("active");
$(".product-nav a").hover(function(){
  let index = $(this).index();
  $(this).addClass("active").siblings().removeClass("active");
  $(".product-list .content").eq(index).addClass("active").siblings().removeClass("active");
})